import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { X } from "react-feather";
import { usePostTags } from "../hooks";

export default function Tag({
  tag,
  isFiltered,
  tagName,
  showDelete = true,
  deleteTag,
  onClick,
}) {
  const history = useHistory();
  const { tagMap, tagIdMap } = usePostTags({ initialize: false });
  const hex2rgba = (hex, alpha = 1) => {
    const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
  };

  const finalTag = useMemo(() => {
    if (tag) {
      return tag;
    } else if (tagName) {
      if (tagMap[tagName]) {
        return tagMap[tagName];
      } else if (tagIdMap[tagName]) {
        return tagIdMap[tagName];
      }
    }
    return null;
  }, [tag, tagName, tagMap, tagIdMap]);

  return !finalTag ? null : (
    <>
      <span
        key={finalTag.name}
        style={{
          backgroundColor: hex2rgba(finalTag.color || "white", 0.3),
          borderColor: hex2rgba(finalTag.color || "white"),
        }}
        className={`post-tags__tag ${isFiltered && "post-tags__tag--filtered"}`}
      >
        <span
          onClick={
            onClick
              ? onClick
              : () => {
                  history.push("/tags");
                }
          }
          className="post-tags__tag-name"
        >
          {finalTag.name === "+" ? (
            <svg
              style={{ marginLeft: "-7px", marginTop: "-4px" }}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-plus"
            >
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          ) : (
            finalTag.name
          )}
        </span>{" "}
        {
          // This will show the x in the tag box:
          //
          //showDelete && (
          //<span onClick={() => deleteTag(finalTag.name)} className="post-tags__x">
          // <X size={12} />
          //</span>
          //)
        }
      </span>
      {
        // This will show the x to the right:
        showDelete && (
          <span
            onClick={() => {
              if (window.confirm("Are you sure you want to delete this tag?")) {
                deleteTag(finalTag.name);
              }
            }}
            className="post-tags__x--to-the-right"
          >
            <X size={18} />
          </span>
        )
      }
    </>
  );
}
